import React, { Component } from "react";

import { Box, Checkbox, Column, Columns, Control, Field, Input, Title } from "@allxsmith/bestax-bulma";
import {Picker} from "../Utils/Picker";

class InsuranceSection extends Component {
  render() {

    let insuranceInfo = (this.props.rental.customer && this.props.rental.customer.id) ? this.props.rental.customer.insurance_info : [];

    let insuranceInfoObjects = insuranceInfo && insuranceInfo.length > 0 ? insuranceInfo.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

    const onInsuranceChange = e => {
      let insuranceInfo = insuranceInfoObjects[e.target.value]
      const toUpdate = {
        target: {
          name: e.target.name,
          value: insuranceInfo
        }
      }
      this.props.onChange(toUpdate);
      // now handle changing all the licence information
      if(insuranceInfo) {
        let otherDataToChange = {
          policy_name: insuranceInfo.policy_name,
          policy_number: insuranceInfo.policy_number,
          insurer: insuranceInfo.insurer,
          insurance_excess: insuranceInfo.insurance_excess,
          insurance_company_email: insuranceInfo.insurance_email,
          insurance_expiry: insuranceInfo.insurance_expiry_date,
          insurance_copy_saved: insuranceInfo.insurance_copy_saved
        }
        this.props.triggerChange(otherDataToChange);
      }
    }


    return (
      <Box>
        <Title>Insurance</Title>
        <Columns isMultiline>
          <Column>
            <Picker
                options={{results: insuranceInfo}}
                label={"Insurance Policy"}
                value={this.props.rental.insurance_policy}
                blank={true}
                name={"insurance_policy"}
                optionField={"policy_number"}
                onChange={onInsuranceChange}
            />
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">Policy Number</label>
              <Control>
                <Input
                  type="text"
                  name="policy_number"
                  onChange={this.props.onChange}
                  value={this.props.rental.policy_number}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Policy Name</label>
              <Control>
                <Input
                  type="text"
                  name="policy_name"
                  onChange={this.props.onChange}
                  value={this.props.rental.policy_name}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Insurer</label>
              <Control>
                <Input
                  type="text"
                  name="insurer"
                  onChange={this.props.onChange}
                  value={this.props.rental.insurer}
                />
              </Control>
            </Field>
          </Column>
            <Column>
            <Field>
              <label className="label">Insurance Email</label>
              <Control>
                <Input
                  type="text"
                  name="insurance_company_email"
                  onChange={this.props.onChange}
                  value={this.props.rental.insurance_company_email}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Control>
              <Field>
                <label className="label">Insurance Excess</label>
                <Input
                  type="number"
                  name="insurance_excess"
                  onChange={this.props.onChange}
                  value={this.props.rental.insurance_excess}
                  required
                />
              </Field>
            </Control>
          </Column>
          <Column>
            <Control>
              <Field>
                <label className="label">Insurance Expiry</label>
                <Input
                  type="date"
                  name="insurance_expiry"
                  onChange={this.props.onChange}
                  value={this.props.rental.insurance_expiry}
                  required
                />
              </Field>
            </Control>
          </Column>
          <Column>
            <Control>
              <Field>
                <label className="label">Insurance Copy Saved</label>
                <Checkbox
                  name="insurance_copy_saved"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.insurance_copy_saved}
                  required
                />
              </Field>
            </Control>
          </Column>
        </Columns>
      </Box>
    );
  }
}

export default InsuranceSection;
